export type Cost = {
  title: string
  description: string
}

export type Benefit = {
  title: string
  description: string
}

export type StackItem = {
  label: string
  name: string
  detail?: string
  value: string
  isCore?: boolean
}

export type Faq = {
  question: string
  answer: string
}

export const costs: Cost[] = [
  {
    title: 'Agotamiento energético',
    description:
      'Terminás el día "cargado" con los problemas ajenos por no tener un cierre claro.',
  },
  {
    title: 'Pacientes que no vuelven',
    description:
      'Si el consultante no ve claridad y evolución, no reagenda.',
  },
  {
    title: 'Inseguridad al cobrar',
    description:
      'Te cuesta subir tus honorarios porque sentís que tu servicio es "improvisado".',
  },
  {
    title: 'Desorden mental',
    description:
      'Consultorios llenos de papeles sueltos y notas que no dicen nada.',
  },
]

export const benefits: Benefit[] = [
  {
    title: 'Mapas corporales pro',
    description:
      'Identificá bloqueos en segundos con guías visuales de centros y flujos.',
  },
  {
    title: 'Preguntas de poder',
    description:
      'Sabé exactamente qué preguntar para desarmar la resistencia del consultante.',
  },
  {
    title: 'Registro profesional',
    description:
      'Llevá fichas clínicas claras que demuestran tu autoridad como terapeuta.',
  },
  {
    title: 'Sesiones fluidas',
    description:
      'Tené una hoja de ruta clara desde que el paciente entra hasta que se va.',
  },
]

export const stack: StackItem[] = [
  {
    label: 'Producto principal',
    name: 'Kit Maestro de Evaluación Energética',
    detail: 'Protocolos + mapas corporales',
    value: '$22.000',
    isCore: true,
  },
  {
    label: 'Bono 1',
    name: 'Escudo Terapéutico',
    detail: 'Limpieza y protección',
    value: '$6.500',
  },
  {
    label: 'Bono 2',
    name: 'Ficha Clínica Holística Imprimible',
    value: '$5.000',
  },
  {
    label: 'Bono 3',
    name: 'Diccionario de Somatización Rápida',
    value: '$7.500',
  },
  {
    label: 'Bono 4',
    name: 'Guía de Cierre y Devolución Impactante',
    value: '$4.500',
  },
  {
    label: 'Bono 5',
    name: 'Script de Ventas y Agendamiento por WhatsApp',
    value: '$6.000',
  },
]

export const faqs: Faq[] = [
  {
    question: '¿Sirve para cualquier terapia?',
    answer:
      'Sí. Los mapas y protocolos son universales. Se adaptan perfectamente si trabajás con energía, cuerpo físico o campo emocional.',
  },
  {
    question: '¿Es difícil de usar?',
    answer:
      'Para nada. Está diseñado para que lo tengas abierto en tu tablet, celu o impreso sobre la mesa y lo consultes de reojo durante la sesión.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'El acceso es inmediato. Una vez realizado el pago, te llega un mail con todo el material digital listo para descargar y usar.',
  },
]

export const techniques = [
  'Reiki',
  'Biodecodificación',
  'Masoterapia',
  'Radiestesia',
]

export const price = {
  total: '$51.500',
  today: '$18.900',
  currency: 'ARS',
}
